"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LottieLoading = void 0;

var _tracebotLoadingAnimation = _interopRequireDefault(require("../../assets/lotties/tracebot-loading-animation.json"));

var _atoms = require("../../atoms");

var _lottieReact = _interopRequireDefault(require("lottie-react"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Slobodan Djordjevic
 */
// Imports
// Lottie Loading
var LottieLoading = function LottieLoading() {
  return /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "LottieLoading"
  }, /*#__PURE__*/_react.default.createElement(_lottieReact.default, {
    loop: true,
    play: "true",
    animationData: _tracebotLoadingAnimation.default,
    style: {
      width: 'auto',
      height: 40
    }
  }));
};

exports.LottieLoading = LottieLoading;